import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { init, page } from "./index";
import { checkAuth } from "../hooks/actions/sessionActions";

/**
 * Inicializa o SDK e registra page_view a cada mudança de rota (usuário autenticado).
 * Deve ficar dentro de BrowserRouter.
 */
const AnalyticsProvider = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (!checkAuth()) return;
    const path = `${location.pathname}${location.search || ""}`;
    page(path);
  }, [location.pathname, location.search]);

  return children;
};

export default AnalyticsProvider;
